module.exports = __webpack_public_path__ + "img/vivid.23bcfd50.png";